{
  "auth": {
    "logoAlt": "Smart Word Labs",
    "checkEmail": {
      "title": "Revisa tu correo",
      "confirmationBody": "Enviamos un enlace de confirmación a <strong>{{email}}</strong>. Confírmalo para activar tu cuenta y luego inicia sesión.",
      "magicLinkBody": "Enviamos un enlace de acceso único a <strong>{{email}}</strong>. Ábrelo en este dispositivo para iniciar sesión.",
      "backToSignIn": "Volver al inicio de sesión de padres"
    },
    "heading": {
      "magicMode": "Inicio de sesión con enlace mágico",
      "signup": "Crea tu cuenta de padre/madre",
      "signin": "Inicio de sesión de padres"
    },
    "subheading": {
      "magicMode": "Ingresa tu correo y te enviaremos un enlace de acceso único.",
      "signup": "Gestiona las clases, la facturación y el progreso de tus hijos en un solo lugar.",
      "signin": "Inicia sesión en tu portal de padres."
    },
    "social": {
      "google": "Continuar con Google",
      "apple": "Continuar con Apple"
    },
    "or": "o",
    "fields": {
      "email": "Correo electrónico",
      "password": "Contraseña",
      "fullName": "Nombre completo",
      "country": "País",
      "phone": "Teléfono"
    },
    "buttons": {
      "pleaseWait": "Espera un momento…",
      "sendMagicLink": "Enviar enlace mágico",
      "createAccount": "Crear cuenta",
      "signIn": "Iniciar sesión"
    },
    "toggle": {
      "useMagicLink": "Enviarme un enlace mágico en su lugar",
      "usePassword": "Usar correo y contraseña en su lugar"
    },
    "footer": {
      "haveAccount": "¿Ya tienes una cuenta?",
      "signIn": "Iniciar sesión",
      "newHere": "¿Nuevo en Smart Word Labs?",
      "bookAssessment": "Reserva una evaluación gratuita"
    },
    "errors": {
      "couldNotSignIn": "No se pudo iniciar sesión",
      "enterEmailFirst": "Ingresa tu correo primero",
      "somethingWentWrong": "Algo salió mal"
    },
    "toasts": {
      "magicLinkSent": "Enlace de acceso enviado — revisa tu correo"
    }
  },
  "reviews": {
    "title": "Reseñas de padres",
    "description": "Comentarios honestos de familias que aprenden con Smart Word Labs. Comparte tu propia experiencia a continuación — las reseñas aparecerán aquí una vez las hayamos revisado.",
    "starsAriaLabel": "{{rating}} de 5 estrellas",
    "starPickerAriaLabel": "Calificación por estrellas",
    "starAriaLabel": "{{count}} estrella",
    "starAriaLabel_plural": "{{count}} estrellas",
    "whatParentsSay": "Lo que dicen los padres",
    "empty": "Aún no hay reseñas publicadas — la tuya podría ser la primera.",
    "form": {
      "title": "Escribe una reseña",
      "yourRating": "Tu calificación",
      "yourName": "Tu nombre",
      "email": "Correo (opcional, no se publica)",
      "childAge": "Edad del niño/a (opcional)",
      "location": "Ciudad / país (opcional)",
      "yourReview": "Tu reseña",
      "bodyPlaceholder": "¿Qué cambió para tu hijo/a? ¿Qué valoras de las clases?",
      "website": "Sitio web",
      "submit": "Enviar reseña"
    },
    "sent": {
      "title": "Reseña recibida",
      "body": "Gracias por compartir tu experiencia. Publicamos las reseñas tras una breve revisión.",
      "writeAnother": "Escribir otra reseña"
    },
    "errors": {
      "chooseRating": "Por favor elige una calificación por estrellas.",
      "tooFast": "¡Eso fue rápido! Tómate un momento e inténtalo de nuevo.",
      "bodyTooShort": "Por favor escribe al menos un par de oraciones.",
      "checkForm": "Por favor revisa el formulario",
      "saveFailed": "No pudimos guardar tu reseña. Inténtalo de nuevo."
    },
    "toasts": {
      "submitted": "Gracias — tu reseña ha sido enviada para revisión."
    }
  }
}
